import { render, staticRenderFns } from "./indexScroll.vue?vue&type=template&id=690dac08&scoped=true&"
import script from "./indexScroll.vue?vue&type=script&lang=js&"
export * from "./indexScroll.vue?vue&type=script&lang=js&"
import style0 from "./indexScroll.vue?vue&type=style&index=0&id=690dac08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690dac08",
  null
  
)

export default component.exports